import { AxiosResponse } from 'axios'
import { http } from '../realisations/Http.realisation'

export class PrintRepository {
    printTranscriptDocuments(transcript_id: number, invoice_number: string): Promise<AxiosResponse<any>> {
        return http.get(`/print/api/transcript-documents/${transcript_id}/${invoice_number}`, { responseType: 'blob' })
    }

    printLtlMassOrders(params: { orderIds: number[] }): Promise<AxiosResponse<Blob>> {
        return http.post('/print/api/ltl-mass-orders', params, { responseType: 'blob', timeout: 120000 })
    }
}
